import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-document-loader',
  version: '1.0.0',
  properties: [
    {
      key: 'loaderType',
      label: 'Loader Type',
      type: 'options',
      required: true,
      default: 'text',
      options: [
        { value: 'text', name: 'Text' },
        { value: 'pdf', name: 'PDF' },
        { value: 'csv', name: 'CSV' },
        { value: 'json', name: 'JSON' },
        { value: 'web', name: 'Web Page' },
      ],
    },
    {
      key: 'source',
      label: 'Source',
      type: 'string',
      required: true,
      placeholder: 'Enter text, URL, or file path',
      typeOptions: {
        rows: 4,
      },
    },
    {
      key: 'metadata',
      label: 'Metadata',
      type: 'json',
      placeholder: '{"source": "document.pdf"}',
      description: 'Additional metadata to attach to documents',
    },
  ],
};

export default schema;
